export default __webpack_public_path__ + "static/media/superior-muelas@3x.03b8c933.png";